import { GirafeHTMLElement } from '@geogirafe/lib-geoportal/base';

export default class ImprintContent extends GirafeHTMLElement {
  templateUrl = './template.html';
  styleUrls = ['../../../../node_modules/@geogirafe/lib-geoportal/styles/common.css', './style.css'];

  public constructor() {
    super('imprint-content');
  }

  override connectedCallback() {
    super.connectedCallback();
    this.render();
  }
}
